// FETCH ALL PROPERTIES FROM PIM DETAILS
export const FETCH_ADDITIONAL_EXPENSE_REQUEST = 'FETCH_ADDITIONAL_EXPENSE_REQUEST';
export const FETCH_ADDITIONAL_EXPENSE_SUCCESS = 'FETCH_ADDITIONAL_EXPENSE_SUCCESS';
export const FETCH_ADDITIONAL_EXPENSE_FAILURE = 'FETCH_ADDITIONAL_EXPENSE_FAILURE';

// CREATE PROPERTIES FOR PIM DETAILS
export const CREATE_ADDITIONAL_EXPENSE_REQUEST = 'CREATE_ADDITIONAL_EXPENSE_REQUEST';
export const CREATE_ADDITIONAL_EXPENSE_SUCCESS = 'CREATE_ADDITIONAL_EXPENSE_SUCCESS';
export const CREATE_ADDITIONAL_EXPENSE_FAILURE = 'CREATE_ADDITIONAL_EXPENSE_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_ADDITIONAL_EXPENSE = 'CREATE_USER_FORM_ADDITIONAL_EXPENSE';

// UPDATE PROPERTIES FOR PIM DETAILS
export const UPDATE_ADDITIONAL_EXPENSE_REQUEST = 'UPDATE_ADDITIONAL_EXPENSE_REQUEST';
export const UPDATE_ADDITIONAL_EXPENSE_SUCCESS = 'UPDATE_ADDITIONAL_EXPENSE_SUCCESS';
export const UPDATE_ADDITIONAL_EXPENSE_FAILURE = 'UPDATE_ADDITIONAL_EXPENSE_FAILURE';

// FETCH SINGLE ADDITIONAL_EXPENSE
export const FETCH_SINGLE_ADDITIONAL_EXPENSE_REQUEST = 'FETCH_SINGLE_ADDITIONAL_EXPENSE_REQUEST';
export const FETCH_SINGLE_ADDITIONAL_EXPENSE_SUCCESS = 'FETCH_SINGLE_ADDITIONAL_EXPENSE_SUCCESS';
export const FETCH_SINGLE_ADDITIONAL_EXPENSE_FAILURE = 'FETCH_SINGLE_ADDITIONAL_EXPENSE_FAILURE';

// DELETE PROPERTIES FOR PIM DETAILS
export const DELETE_ADDITIONAL_EXPENSE_REQUEST = 'DELETE_ADDITIONAL_EXPENSE_REQUEST';
export const DELETE_ADDITIONAL_EXPENSE_SUCCESS = 'DELETE_ADDITIONAL_EXPENSE_SUCCESS';
export const DELETE_ADDITIONAL_EXPENSE_FAILURE = 'DELETE_ADDITIONAL_EXPENSE_FAILURE';

// USERFORM RESET

export const ADDITIONAL_EXPENSE_USERFORM_RESET = 'ADDITIONAL_EXPENSE_USERFORM_RESET';
